import { createContext } from "react";

export type MessageListener = (payload: Payload) => void;

export type MessageContext = {
    post(payload: Payload): void;
    addListener(func: MessageListener): void;
    removeListener(func: MessageListener): void;
}

export type ModalPayload = {
    message: "myhealth-booking-ui-modal",
    value: "open" | "close"
} | {
    message: "myhealth-booking-ui-widget-resize",
    value: number | undefined
} | {
    message: "myhealth-booking-ui-launch",
    value: string
} | {
    message: "myhealth-booking-ui-after-hours",
    value?: boolean
}

type Payload = string | ModalPayload;

function invalidMethod(..._args: unknown[]) {
    throw new Error("Use MessageContext outside of Provider");
}

export const messageContext = createContext<MessageContext>({
    post: invalidMethod,
    addListener: invalidMethod,
    removeListener: invalidMethod
});